import script from "./teachingLog.vue?vue&type=script&setup=true&lang=js"
export * from "./teachingLog.vue?vue&type=script&setup=true&lang=js"

import "./teachingLog.vue?vue&type=style&index=0&id=6728e1ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6728e1ea"]])

export default __exports__